const { Dialog, DialogTitle, DialogContent, Box, Typography, DialogActions, Button } = require("@mui/material");


export function DlspTaskDetailsQAOwnershipDialog({open, onClose, onClaimOwnership}) {

    return (
        <Dialog open={open} onClose={() => onClose()}>
            <DialogTitle>Become the Owner for QA?</DialogTitle>
            <DialogContent>
                <Box sx={{my: 4}}>
                    <Typography variant="body1">You are a QA reviewer. This task does not have a QA owner.</Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{justifyContent: 'space-between', alignItems: 'center'}}>
                <Button variant="contained" onClick={() => onClaimOwnership()} autoFocus>Claim This Task</Button>
                <Button variant="text" onClick={() => onClose()} autoFocus>Not Yet</Button>
            </DialogActions>
        </Dialog>
    )
}